var _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 60.0005,
    cy: 60.6035,
    r: 60,
    fill: "url(#paint0_linear_11433_127957)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.0005,
    cy: 60,
    r: 50,
    fill: "url(#paint1_linear_11433_127957)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11433_127957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.4071 67.696C53.0166 68.0865 52.3834 68.0865 51.9929 67.696L45.0071 60.7102C44.6166 60.3197 43.9834 60.3197 43.5929 60.7102L42.2071 62.096C41.8166 62.4865 41.8166 63.1197 42.2071 63.5102L51.9929 73.296C52.3834 73.6865 53.0166 73.6865 53.4071 73.296L75.9929 50.7102C76.3834 50.3197 76.3834 49.6865 75.9929 49.296L74.6071 47.9102C74.2166 47.5197 73.5834 47.5197 73.1929 47.9102L53.4071 67.696Z",
    fill: "#F4FBFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11433_127957",
    x1: 125.407,
    y1: 4.21906,
    x2: -78.5016,
    y2: 154.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910644,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11433_127957",
    x1: 89.9567,
    y1: 21.3495,
    x2: 6.87163,
    y2: 129.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F2328"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11433_127957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(35.5 36)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.3daf47c4ad325cc8beb8d11d08c18e8b.svg";
export { ForwardRef as ReactComponent };